import { createIcon } from './icon-utils';

export const ArrowRightIcon = createIcon({
  path: 'M3.897 2.718c-.286-.3-.275-.775.025-1.06.3-.287.774-.276 1.06.024L8.342 5.2c.178.186.276.435.276.692 0 .257-.098.506-.276.692l-3.36 3.518c-.286.3-.76.31-1.06.025-.3-.286-.31-.761-.025-1.06l3.031-3.175-3.03-3.174z',
  style: { height: 12, width: 12 },
  viewBox: '0 0 12 12',
});
